<template>
  <p-workflow v-if="$hasPermission('workflows.read')" />
  <p-not-found v-else />
</template>

<script>
import NotFound from './../components/NotFound.vue';
import Workflow from '../components/workflow/Workflow.vue';

export default {
  components: {
    'p-workflow': Workflow,
    'p-not-found': NotFound
  }
};
</script>
